module.exports = __webpack_public_path__ + "img/schedule_sp.d2833bfe.svg";